import {
  IsNotEmpty,
  IsArray,
  ValidateNested,
  IsIn,
  ValidateIf,
  IsObject,
  ArrayMinSize,
} from "class-validator";
import { Type } from "class-transformer";

import { QueryDto } from "../query";
import { IAdapterUserStatusEditActionAsync } from "./adapter-user-status-edit-action-async.interface";
import { AdapterUserStatusDto } from "./adapter-user-status-edit-action.dto";

export class AdapterUserStatusEditActionAsyncDto implements IAdapterUserStatusEditActionAsync {
  @IsNotEmpty()
  @IsIn(["workorder", "operation"])
  entity_name: "workorder" | "operation";

  @ValidateIf((o) => !o.query)
  @IsArray()
  @ArrayMinSize(1)
  entity_ids?: string[];

  @ValidateIf((o) => !o.entity_ids)
  @IsObject()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;

  @IsNotEmpty()
  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => AdapterUserStatusDto)
  with_number: AdapterUserStatusDto[];

  @IsNotEmpty()
  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => AdapterUserStatusDto)
  without_number: AdapterUserStatusDto[];
}
